export const routesProd = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'ni ni-archive-2 text-green',
    active: true,
  },
  {
    collapse: true,
    title: 'Order Confirmation',
    icon: 'ni ni-shop text-primary',
    name: 'ocCollapse',
    active: true,
    views: [
      {
        path: '/orderconfirmation/new',
        title: 'Create New',
        miniName: 'C',
        active: true,
      },
      {
        path: '/orderconfirmation/view',
        title: 'Amend/Repeat',
        miniName: 'A',
        active: true,
      },
      {
        path: '/orderconfirmation/view/draft',
        title: 'Draft',
        miniName: 'D',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Stock Management',
    icon: 'ni ni-ungroup text-orange',
    name: 'stockCollapse',
    active: true,
    views: [
      {
        path: '/stockmanagement/live',
        title: 'Live (Assigned to OC)',
        miniName: 'L',
        active: true,
      },
      {
        path: '/stockmanagement/unassigned',
        title: 'Inventory (Unassigned)',
        miniName: 'I',
        active: true,
      },
      {
        path: '/stockmanagement/cabage',
        title: 'Cabage (Clearance)',
        miniName: 'C',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Critical Path',
    icon: 'ni ni-ui-04 text-info',
    name: 'pathCollapse',
    active: true,
    views: [
      {
        path: '/criticalpath/uk',
        title: 'UK Critical Path',
        miniName: 'U',
        active: true,
      },
      {
        path: '/criticalpath/turkey',
        title: 'Turkey Critical Path',
        miniName: 'T',
        active: true,
      },
      {
        path: '/criticalpath/us',
        title: 'US Critical Path',
        miniName: 'U',
        active: false,
      },
    ],
  },
  {
    collapse: true,
    title: 'Dispatched Stock',
    icon: 'ni ni-single-copy-04 text-pink',
    name: 'dispatchedCollapse',
    active: true,
    views: [
      {
        path: '/dispatchedstock',
        title: 'Dispatched Stock',
        miniName: 'D',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Management Database',
    icon: 'ni ni-align-left-2 text-default',
    name: 'managementCollapse',
    active: true,
    views: [
      {
        path: '/managementdatabase/grnd',
        title: 'Grnd',
        miniName: 'G',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Application Management',
    icon: 'ni ni-map-big text-primary',
    name: 'applicationCollapse',
    active: true,
    views: [
      {
        path: '/applicationmanagement/users/list',
        title: 'Users',
        miniName: 'U',
        active: true,
      },
      {
        path: '/applicationmanagement/brands/list',
        title: 'Brands',
        miniName: 'B',
        active: true,
      },
      {
        path: '/applicationmanagement/factories/list',
        title: 'Factories',
        miniName: 'F',
        active: true,
      },
      {
        path: '/applicationmanagement/groups/list',
        title: 'Groups',
        miniName: 'G',
        active: true,
      },
      {
        path: '/applicationmanagement/blankstockprofiles/list',
        title: 'Blank Stock Profiles',
        miniName: 'BSP',
        active: true,
      },
    ],
  },
];

export const routesDev = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'ni ni-archive-2 text-green',
    active: true,
  },
  {
    collapse: true,
    title: 'Order Confirmation',
    icon: 'ni ni-shop text-primary',
    name: 'ocCollapse',
    active: true,
    views: [
      {
        path: '/orderconfirmation/new',
        title: 'Create New',
        miniName: 'C',
        active: true,
      },
      {
        path: '/orderconfirmation/view',
        title: 'Amend/Repeat',
        miniName: 'A',
        active: true,
      },
      {
        path: '/orderconfirmation/view/draft',
        title: 'Draft',
        miniName: 'D',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Stock Management',
    icon: 'ni ni-ungroup text-orange',
    name: 'stockCollapse',
    active: true,
    views: [
      {
        path: '/stockmanagement/live',
        title: 'Live (Assigned to OC)',
        miniName: 'L',
        active: true,
      },
      {
        path: '/stockmanagement/unassigned',
        title: 'Inventory (Unassigned)',
        miniName: 'I',
        active: true,
      },
      {
        path: '/stockmanagement/cabage',
        title: 'Cabage (Clearance)',
        miniName: 'C',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Critical Path',
    icon: 'ni ni-ui-04 text-info',
    name: 'pathCollapse',
    active: true,
    views: [
      {
        path: '/criticalpath/uk',
        title: 'UK Critical Path',
        miniName: 'U',
        active: true,
      },
      {
        path: '/criticalpath/turkey',
        title: 'Turkey Critical Path',
        miniName: 'T',
        active: true,
      },
      {
        path: '/criticalpath/us',
        title: 'US Critical Path',
        miniName: 'U',
        active: false,
      },
    ],
  },
  {
    collapse: true,
    title: 'Dispatched Stock',
    icon: 'ni ni-single-copy-04 text-pink',
    name: 'dispatchedCollapse',
    active: true,
    views: [
      {
        path: '/dispatchedstock',
        title: 'Dispatched Stock',
        miniName: 'D',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Management Database',
    icon: 'ni ni-align-left-2 text-default',
    name: 'managementCollapse',
    active: true,
    views: [
      {
        path: '/managementdatabase/grnd',
        title: 'Grnd',
        miniName: 'G',
        active: true,
      },
    ],
  },
  {
    collapse: true,
    title: 'Application Management',
    icon: 'ni ni-map-big text-primary',
    name: 'applicationCollapse',
    active: true,
    views: [
      {
        path: '/applicationmanagement/users/list',
        title: 'Users',
        miniName: 'U',
        active: true,
      },
      {
        path: '/applicationmanagement/brands/list',
        title: 'Brands',
        miniName: 'B',
        active: true,
      },
      {
        path: '/applicationmanagement/factories/list',
        title: 'Factories',
        miniName: 'F',
        active: true,
      },
      {
        path: '/applicationmanagement/groups/list',
        title: 'Groups',
        miniName: 'G',
        active: true,
      },
      {
        path: '/applicationmanagement/blankstockprofiles/list',
        title: 'Blank Stock Profiles',
        miniName: 'BSP',
        active: true,
      },
    ],
  },
];
